import classNames from 'classnames';
import type {
  GroupTestNode,
  SecuritySchemaNodeComponentProps,
} from 'components/SecuritySchema/model/SecuritySchemaNode';
import { renderTestNodeMetaInfo } from 'components/SecuritySchema/nodeComponents/renderTestNodeMetaInfo';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const CGroupTestNode: FC<
  SecuritySchemaNodeComponentProps<GroupTestNode>
> = ({ node, context }) => {
  const msg = useLocale();
  const msgTest = msg.securitySchema.test;
  return (
    <div
      className={classNames(
        'security-tree-node security-tree-node--test-group',
        `security-tree-node--${node.group}`,
        context.highlightedSubtree && 'security-tree-node--highlighted',
      )}
    >
      {renderTestNodeMetaInfo(node, msg)}
      <p className='security-tree-node__heading'>
        {msgTest.groupLabels[node.group]}
        {node.group !== 'not' && (
          <span className='badge badge-light text-uppercase ml-lgu-2'>
            <FormattedMessage
              id='securitySchema.numberOfItems'
              defaultMessage={msg.securitySchema.numberOfItems}
              values={{ number: node.children.length }}
            />
          </span>
        )}
      </p>
    </div>
  );
};
